import React, { useMemo } from "react";
// import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import {
  extractDate,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const WebsitePolicies = () => {
  const { getText } = useLanguageTranslation();
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: rndData = [], isLoading: rndIsLoading } =
    useGetProtectedApiDataQuery({
      url: "website_policies",
      lang: languageType,
    });

  const pageBody = rndData[0]?.body ?? "No content available";
  console.log(pageBody);

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(rndData)?.changed);
  }, [rndData]);

  if (rndIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        titleLink={"/archived-news"}
        levelTwo={false}
        levelThree={false}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container about_inntxt">
            <div className="row">
              <div className="container">
                <div
                  dangerouslySetInnerHTML={{ __html: pageBody }}
                  className="mb-4"
                ></div>
                <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

                {/* <div className="table-responsive ">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th style={{ width: "56px" }}>
                          {getText("S.No.", "क्र. सं.")}
                        </th>
                        <th>{getText("Details", "विवरण")}</th>
                        <th>{getText("Download", "डाउनलोड")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rndData.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {index + 1}
                          </td>
                          <td data-key={getText("Details", "विवरण")}>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: item.title,
                              }}
                            ></p>
                          </td>
                          <td data-key={getText("Download", "डाउनलोड")}>
                            <>
                              <a
                                href={`${process.env.REACT_APP_IMAGE_URL}/${item?.field_upload_documents}`}
                                target="_blank"
                                className="pdf_icon"
                              >
                                <div className="pdf-icon">
                                  <img
                                    src="./images/pdf-icon.png"
                                    alt="pdf-icon"
                                    className="ml-2"
                                  />
                                </div>
                              </a>
                              <span className="ml-2">({item.filesize})</span>
                            </>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebsitePolicies;
